const {ESLMediaQuery} = require('@exadel/esl/modules/esl-media-query/core');
const {AmpersandApp: productCatalogApp, AmpersandView} = require('catalog/libs');

const HPEConstants = require('../../../base/hpe.constants');
const browser = require('core/helpers/browser');

const FilterListTemplate = require('../templates/hpe.productlist.filterlist.template.tpl');
const FacetCollectionView = require('./hpe.productlist.facet.view');

/**
 * Product Filters View
 * TODO: lots of jQuery in here as part of port from older jQuery version
 * view hierarchy: filterlist (this) > facet collection > facet > filtergroup collection > filter group > filter collection > filter
 */
module.exports = AmpersandView.extend({

    /**
     * initialization
     */
    initialize: function() {

        //get dom reference to the container node that the scrolling filter list references
        this.relativeElement = document.querySelector('.main-content');

        //initial isMobile determination
        this.model.isMobile = this.isMobileBreakpoint();

        //event bindings
        this.onScroll = this.onScrollEvent.bind(this);
        this.updateScrollPosition = this.updateContainerPosition.bind(this);
        this.onBreakpointChange = this.onBreakpointChangeEvent.bind(this);
        productCatalogApp.on(HPEConstants.catalog.CATALOG_SCROLL_TOP_CHANGE, this.onResultsScrollTopChange, this);

        //these product list events should trigger a scroll refresh
        this.on('change:rendered', this.refresh, this);
        productCatalogApp.on('SPECS_CHANGE', this.refresh, this);
        productCatalogApp.on(HPEConstants.catalog.FILTER_COLLAPSE_CHANGE, this.refresh, this);

        //breakpoint change event
        this.onBreakpointChange();
        ESLMediaQuery.for('@XS').addEventListener(this.onBreakpointChange);

        //one approach to try to isolate behavior from touch based devices
        this.isNotMobileOS = !browser.isMobileOS;

        //initialization and events for non-mobile/tablet + non-touch view
        if (this.isNotMobileOS) {
            this.updateScrollValues();
            this.updateContainerPosition();
            window.addEventListener('scroll', this.onScroll);
        }
    },

    /**
     * destructor, called by product list app destroy()
     */
    destroy: function() {
        //remove event listeners
        window.removeEventListener('scroll', this.onScroll);
        ESLMediaQuery.for('@XS').removeEventListener(this.onBreakpointChange);
        this.off('change:rendered', this.refresh, this);
        productCatalogApp.off('SPECS_CHANGE', this.refresh, this);
        productCatalogApp.off(HPEConstants.catalog.FILTER_COLLAPSE_CHANGE, this.refresh, this);
        productCatalogApp.off(HPEConstants.catalog.CATALOG_SCROLL_TOP_CHANGE, this.onResultsScrollTopChange, this);

        this.relativeElement = null;
    },

    /**
     * bindings
     */
    bindings: {
        'model.labelMobileOpen': {
            type: 'text',
            selector: '.filterlist-mobile-open'
        },
        'model.labelMobileClose': {
            type: 'text',
            selector: '.filterlist-mobile-close'
        },
        'model.labelClear': {
            type: 'text',
            selector: '.filterlist-clear-all'
        },
        'model.labelResults': {
            type: 'text',
            selector: '.filterlist-results-count'
        },
        'model.isMobileNavOpen': [
            {
                type: 'booleanClass',
                selector: '.filterlist',
                name: 'open'
            },
            {
                type: function(el, value) {
                    el.setAttribute('aria-expanded', value);
                },
                selector: '.filterlist-mobile-open'
            },
            {
                type: function(el, value) {
                    var hiddenValue = (this.model.isMobile) ? !value : false;
                    el.setAttribute('aria-hidden', hiddenValue);
                },
                selector: '.filterlist-mobile-nav',
                name: 'aria-hidden'
            },
            {
                //access dom elements outside of the scope of the view
                type: function (el, value) {
                    var topY;
                    if (value) {

                        //position underlying content at viewport top except on PDP
                        if (!productCatalogApp.isTabInstance) {
                            topY = $('.product-listing-tab').offset().top || 0;
                            $('body').css('top', -topY + 'px');
                        }

                        //prevent body overflow
                        $('body').addClass('nav-active nav-active-filterlist');

                        //without specific content height there will be no scrolling
                        $('.filterlist-content').css('height', ($(window).height() - 50) + 'px');

                        //add darkened overlay
                        $('.product-listing-tab').addClass('overlaid');

                    } else {

                        //undo nav settings
                        $('body').removeClass('nav-active nav-active-filterlist').css('top', '');

                        //position underlying content at viewport top except on PDP
                        if (this.model.isMobile && (!productCatalogApp.isTabInstance) && (!productCatalogApp.isInitialRender)) {
                            window.scrollTo(0, $('.product-listing-tab').offset().top);
                        }

                        //remove darkened overlay
                        $('.product-listing-tab').removeClass('overlaid');
                    }
                },
                selector: '.filterlist'
            }
        ],
        'model.isMobileNavTransitioning': {
            type: function (el, value) {
                var tabContainerEl = document.querySelector('.dynamic-tab-container-panel');
                //access dom element outside of the scope of the view
                if (tabContainerEl) {
                    if (value) {
                        tabContainerEl.classList.add('tab-productlist-overlay');
                    } else {
                        tabContainerEl.classList.remove('tab-productlist-overlay');
                    }
                }
            },
            selector: '.filterlist'
        },
        'model.clearAllDisabled': {
            type: 'booleanAttribute',
            selector: '.filterlist-clear-all',
            name: 'disabled',
            invert: true
        },
        'model.shouldDisplay': {
            type: 'booleanClass',
            selector: '.filterslist-catalog',
            name: 'hidden',
            invert: true
        }
    },

    template: FilterListTemplate,

    /**
     * subviews
     */
    subviews: {
        filters: {
            selector: '[data-hook=hpe-filter-collection-container]',
            waitFor: 'model.facets',
            prepareView: function(el) {
                return new FacetCollectionView({
                    el: el,
                    collection: this.model.facets
                });
            }
        }
    },

    /**
     * events
     */
    events: {
        'click .filterlist-mobile-open': 'onMobileFilterlistOpen',
        'click .filterlist-mobile-close': 'onMobileFilterlistClose',
        'click .filterlist-clear-all': 'onClearAll',
        'transitionend .filterlist': 'onMobileTransitionEvent'
    },

    /**
     * force refresh positioning of view state/placement/scroll values
     */
    refresh: function() {

        var that = this;

        if ((!this.model.isMobile) && this.isNotMobileOS) {

            //force refresh
            this.model.scrollVals.isForceScrollPosition = true;

            //refresh shared page values
            setTimeout(function() {
                that.updateScrollValues();
                that.onScrollEvent();
            }, 300);
        }
    },

    /**
     * update values/measurements commonly used in desktop scrolling calculations
     */
    updateScrollValues: function() {

        var jqContainerElement = $('.filterlist');
        var jqRelativeElement = $(this.relativeElement);

        //reset elements before measuring
        jqContainerElement.css({
            position: '',
            top: '',
            bottom: '',
            width: '',
            height: ''
        });

        //save measured values
        this.model.isMobile = this.isMobileBreakpoint();
        this.model.scrollVals.windowHeight = $(window).height();
        this.model.scrollVals.containerHeight = (jqContainerElement.length) ? jqContainerElement.outerHeight() : 0;
        this.model.scrollVals.containerWidth = (jqContainerElement.length) ? jqContainerElement.outerWidth() : 160;
        this.model.scrollVals.containerOffsetTop = (jqContainerElement.length) ? jqContainerElement.offset().top : 0;
        this.model.scrollVals.designTopOffset = (productCatalogApp.isTabInstance) ? '69' : '0';
        this.model.scrollVals.relativeElementHeight = (jqRelativeElement.length) ? jqRelativeElement.outerHeight() : 0;
        this.model.scrollVals.relativeElementBottom = (jqRelativeElement.length) ? jqRelativeElement.offset().top + this.model.scrollVals.relativeElementHeight : 0;
    },

    /**
     * handle window scroll event
     */
    onScrollEvent: function() {
        if (!this.model.isMobile) {
            this.model.scrollVals.scrollTopMostRecent = $(window).scrollTop();
            this.requestScrollTick();
        }
    },

    /**
     * handle breakpoint change event
     * @param {object} e event object
     * @param {string} breakpoint descriptor of the current breakpoint
     */
    onBreakpointChangeEvent: function(e, breakpoint) {
        //force close nav and mobile view if moving outside of xs breakpoint
        if (this.model.isMobile && !this.isMobileBreakpoint()) {
            this.model.isMobile = false;
            this.model.isMobileNavOpen = false;
            this.model.isMobileNavTransitioning = false;
            $('body').removeClass('nav-active modal-open');
            $('.dynamic-tab-container-panel').removeClass('open');
            $('.dynamic-tab-container-panel-close').removeClass('open');
            $('.filterlist-mobile-nav').attr('aria-hidden', 'false');
        } else {
            this.model.isMobile = this.isMobileBreakpoint();
        }
    },

    /**
     * throttle requests to requestanimationframe
     */
    requestScrollTick: function() {
        var that = this;
        if (!this.model.scrollVals.isScrollTick) {
            window.requestAnimationFrame(that.updateScrollPosition);
        }
        this.model.scrollVals.isScrollTick = true;
    },

    /**
     * update the filters element position to locked/scrolling
     */
    updateContainerPosition: function() {

        var scrollTop, isScrollingUp, isContainerAtBottom, isContainerTallerThanViewport, propSet, propSets;

        var jqContainerElement = $('.filterlist');

        //do not proceed if mobile or if other scrolling activity is active on page (auto-scroll to top on new results)
        if ((!this.model.isMobile && this.isNotMobileOS) && (!this.model.scrollVals.isAutoScrollBusy)) {

            //do not proceed unless relative element height is taller than container (filters)
            if (this.model.scrollVals.containerHeight < this.model.scrollVals.relativeElementHeight) {

                scrollTop = this.model.scrollVals.scrollTopMostRecent;
                isScrollingUp = (this.model.scrollVals.scrollTopPrevious > scrollTop);
                isContainerAtBottom = ((scrollTop + this.model.scrollVals.windowHeight) >= (this.model.scrollVals.containerHeight + this.model.scrollVals.containerOffsetTop));
                isContainerTallerThanViewport = (this.model.scrollVals.containerHeight >= this.model.scrollVals.windowHeight);
                propSet = '0';
                this.model.scrollVals.scrollTopPrevious = scrollTop;

                //container may have one of the following scrolling sets applied if not using the default
                //if no conditions apply, use the default propSet (zero)
                propSets = {
                    '0': { position: '', top: '', bottom: '' },
                    '1': { position: 'fixed', top: this.model.scrollVals.designTopOffset + 'px', bottom: 'auto', width: this.model.scrollVals.containerWidth + 'px', height: this.model.scrollVals.containerHeight + 'px' },
                    '2': { position: 'fixed', top: 'auto', bottom: '0', width: this.model.scrollVals.containerWidth + 'px', height: this.model.scrollVals.containerHeight + 'px' },
                    '3': { position: 'absolute', top: ((this.model.scrollVals.relativeElementBottom - this.model.scrollVals.containerHeight) - this.model.scrollVals.containerOffsetTop) + 'px', bottom: 'auto', width: this.model.scrollVals.containerWidth + 'px', height: this.model.scrollVals.containerHeight + 'px' },
                    '4': { position: 'absolute', top: (this.model.scrollVals.containerPositionedOffsetTop - this.model.scrollVals.containerOffsetTop) + 'px', bottom: 'auto', width: this.model.scrollVals.containerWidth + 'px', height: this.model.scrollVals.containerHeight + 'px' }
                };

                //*** UP ***
                //positioning if user is scrolling up
                if (isScrollingUp) {

                    //container is taller than viewport
                    if (isContainerTallerThanViewport) {

                        //position unless scroll position already at top
                        if (this.model.scrollVals.yUpScrollPosition && (scrollTop > this.model.scrollVals.containerOffsetTop)) {

                            //set container position to the scrolling "turnaround" value so user can scroll up
                            propSet = '4';

                            //container top is at top of screen
                            if (scrollTop < this.model.scrollVals.containerPositionedOffsetTop) {
                                propSet = '1';

                                //set new absolute top value, calculate new location to lock bottom
                                if (scrollTop < this.model.scrollVals.containerPositionedOffsetTop) {
                                    this.model.scrollVals.containerPositionedOffsetTop = scrollTop;
                                    this.model.scrollVals.yBottomLock = ((this.model.scrollVals.containerPositionedOffsetTop + this.model.scrollVals.containerHeight) - this.model.scrollVals.windowHeight);
                                }
                            }
                        }

                    //container is shorter than viewport height
                    } else {

                        //container locked to bottom of relative element bottom
                        if ((this.model.scrollVals.containerHeight + scrollTop) >= this.model.scrollVals.relativeElementBottom) {
                            propSet = '3';

                        //container locked to top of scren
                        } else if (scrollTop > this.model.scrollVals.containerOffsetTop) {
                            propSet = '1';
                        }
                    }

                //*** DOWN ***
                //positioning if user is scrolling down
                } else {

                    //only if filter rail is taller than viewport
                    if (isContainerTallerThanViewport) {

                        //not locked to top or bottom of viewport
                        if (scrollTop < this.model.scrollVals.yBottomLock) {

                            propSet = '4';

                            //update y comparison position
                            if (scrollTop >= this.model.scrollVals.yUpScrollPosition) {
                                this.model.scrollVals.yUpScrollPosition = (scrollTop + (this.model.scrollVals.containerHeight + this.model.scrollVals.containerOffsetTop));
                            }

                        //possibly locked to viewport bottom
                        } else {

                            //bottom of container is at bottom of screen
                            if (isContainerAtBottom) {
                                if (scrollTop > this.model.scrollVals.yBottomLock) {
                                    this.model.scrollVals.yBottomLock = scrollTop;
                                    propSet = '2';
                                } else {
                                    propSet = '4';
                                }
                                if (scrollTop >= this.model.scrollVals.yUpScrollPosition) {
                                    this.model.scrollVals.yUpScrollPosition = (scrollTop + (this.model.scrollVals.containerHeight + this.model.scrollVals.containerOffsetTop));
                                }
                            }
                        }

                        // bottom of relative element is past bottom of screen
                        if ((scrollTop + this.model.scrollVals.windowHeight) >= this.model.scrollVals.relativeElementBottom) {
                            propSet = '3';
                            if (scrollTop >= this.model.scrollVals.yUpScrollPosition) {
                                this.model.scrollVals.yUpScrollPosition = scrollTop;
                            }
                        }

                        //update absolute top positioning value
                        this.model.scrollVals.containerPositionedOffsetTop = jqContainerElement.offset().top;

                    } else {

                        //container is at top of screen
                        if (scrollTop > this.model.scrollVals.containerOffsetTop) {
                            propSet = '1';
                        }

                        //container bottom position matches bottom position of relative element
                        if ((this.model.scrollVals.containerHeight + scrollTop) >= this.model.scrollVals.relativeElementBottom) {
                            propSet = '3';
                        }
                    }
                }

                //update the css properties of the container element only if different from previous value
                if ((propSet !== this.model.scrollVals.previousScrollPositionProps) || this.model.scrollVals.isForceScrollPosition) {
                    jqContainerElement.css(propSets[propSet]);
                    if (propSet !== '0') {
                        jqContainerElement.addClass('is-fixed');
                    } else {
                        jqContainerElement.removeClass('is-fixed');
                    }
                    this.model.scrollVals.previousScrollPositionProps = propSet;
                }

                //reset
                if (scrollTop < this.model.scrollVals.containerOffsetTop) {
                    this.model.scrollVals.yBottomLock = 0;
                }
                this.model.scrollVals.isForceScrollPosition = false;
            }

            this.model.scrollVals.isScrollTick = false;
        }
    },

    /**
     * determine if this is mobile breakpoint
     * @return {Boolean} true if mobile breakpoint
     */
    isMobileBreakpoint: function() {
        return ESLMediaQuery.for('@XS').matches;
    },

    /**
     * handle clicks to the clear all button
     * @param {object} e event object
     */
    onClearAll: function(e) {
        e.preventDefault();
        productCatalogApp.trigger(HPEConstants.catalog.VIEW_UPDATE_REQUEST, {
            'type': 'clearall'
        });
    },

    /**
     * handle clicks to the open filter CTA in mobile view
     * @param {object} e event object
     */
    onMobileFilterlistOpen: function(e) {

        e.preventDefault();

        //open the nav
        this.model.isMobileNavTransitioning = true;
        this.model.isMobileNavOpen = true;
    },

    /**
     * handle clicks to the open filter CTA in mobile view
     * @param {object} e event object
     */
    onMobileFilterlistClose: function(e) {

        e.preventDefault();

        //close the nav
        this.model.isMobileNavOpen = false;
    },

    /**
     * handle auto 'scroll-to-top' on results change events
     * @param {object} settings payload with "busy" boolean
     */
    onResultsScrollTopChange: function(settings) {

        //save setting
        this.model.scrollVals.isAutoScrollBusy = (typeof settings !== 'undefined') ? settings.busy : false;

        //if auto scroll has just ended or is not busy, update desktop scrolling positions
        if (!this.model.scrollVals.isAutoScrollBusy) {
            this.updateScrollValues();
            this.updateContainerPosition();

        //when auto-scroll becomes busy, reset positioned scrolling of filterlist (no not use cached element)
        } else {
            document.querySelector('.filterlist').removeAttribute('style');
        }
    },

    /**
     * handle mobile navigation css transition complete event
     */
    onMobileTransitionEvent: function() {
        this.model.isMobileNavTransitioning = this.model.isMobileNavOpen;
    }

});
